// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_23H1R","tc":"_2Nurm","checkInput":"_3XNac","spin":"L29qt","error":"_1KxY_","otpWrap":"_3MhG3","inputWrap":"uQz0U"};